import React from 'react';
import '../styleFiles/Certificates.css';

const Certificates = () => {
  const certs = [
  {
    title: "Machine Learning Specialization",
    issuer: "Stanford University & DeepLearning.AI",
    platform: "Coursera",
    year: "2024",
    icon: "fa-brain",
    certificate: "ML-Spe.pdf",
    notes: ["ML-SL.pdf", "ML-NN.pdf"],
    description: "Comprehensive series covering supervised learning, deep learning, and machine learning deployment practices using Python and real-world examples."
  },
  {
    title: "Unsupervised Learning, Recommenders & Reinforcement Learning",
    issuer: "Stanford University & DeepLearning.AI",
    platform: "Coursera",
    year: "2024",
    icon: "fa-robot",
    certificate: "RL-UL.pdf",
    notes: ["ML-UL.pdf", "ML-RL.pdf"],
    description: "Explores clustering algorithms, recommender systems, and reinforcement learning with a strong theoretical and practical foundation."
  },
  {
    title: "Introduction to Deep Learning & Neural Networks with Keras",
    issuer: "IBM",
    platform: "Coursera",
    year: "2024",
    icon: "fa-network-wired",
    certificate: "DL-Kears.pdf",
    notes: [],
    description: "Introduces deep learning fundamentals using Keras, including feedforward neural networks and backpropagation concepts."
  },
  {
    title: "Introduction to Computer Vision and Image Processing",
    issuer: "IBM",
    platform: "Coursera",
    year: "2024",
    icon: "fa-eye",
    certificate: "CV.pdf",
    notes: ["CV.pdf"],
    description: "Covers the basics of image processing, OpenCV, Pillow, and convolutional neural networks for computer vision applications."
  },
  {
    title: "React Development",
    issuer: "IBM",
    platform: "Coursera",
    year: "2024",
    icon: "fa-react",
    certificate: "React-IBM.pdf",
    notes: ["React.pdf"],
    description: "Teaches React fundamentals, component-based development, hooks, routing, and integration with backend services."
  },
  {
    title: "React Development",
    issuer: "Mhara Tech",
    platform: "Private",
    year: "2024",
    icon: "fa-laptop-code",
    certificate: "React-Manra-Tech.pdf",
    notes: ["React.pdf"],
    description: "Practical hands-on training on building modern web applications using React, with emphasis on design patterns and UI structuring."
  },
  {
    title: "Machine Learning Using Python",
    issuer: "IBM",
    platform: "Coursera",
    year: "2024",
    icon: "fa-chart-line",
    certificate: "SL.pdf",
    notes: ["SL.pdf"],
    description: "Introduces core machine learning concepts using Python and scikit-learn including regression, classification, and model evaluation."
  },
  {
    title: "Python for Data Science, AI & Development",
    issuer: "IBM",
    platform: "Coursera",
    year: "2024",
    icon: "fa-laptop-code",
    certificate: "PY-ML.pdf",
    notes: [],
    description: "Foundational course in Python programming tailored for data analysis, AI applications, and software development."
  }
];


  return (
    <section>
        <h1 className='component-title'> My Earned Certificates via My Journey </h1>
         {certs.map((cert) => (
            <section className='Container'>
                <div>
                    <h5> {cert.title} </h5>
                    <section className='m-2' style={{"text-align":"left"}}>
                        <h5> 📜 <strong> Issued by:</strong> {cert.issuer} </h5>
                        <h5> 🔗 <strong>Platform:</strong> {cert.platform} </h5>
                        <h5> 📅 <strong>Year:</strong> {cert.year} </h5>
                        <span> ✅ <strong>Description:</strong> {cert.description} </span>
                        <br/>
                        <button className='LightButton'> <i class="fa-solid fa-download"></i> <a href={"/assets/Certificates/"+cert.certificate} download> Download Certificate </a> </button>
                        {cert.notes.map((note, index) => (
                          <button className='LightButton'> <i class="fa-solid fa-download"></i> <a href={"/assets/Notes/"+note} download> Download Note - {index+1}</a> </button>
                        ))}
                    </section>
                </div>
            </section>
        ))}
    </section>
  );
};

export default Certificates;